import { forwardRef } from 'react';
import IconBase from '../IconBase';
import { Icon } from '../types';

const Advice: Icon = forwardRef((props, ref) => (
  <IconBase viewBoxBase={780} ref={ref} {...props}>
    <path d='m113.56 540.29c-3.25 0-6.53-.7-9.65-2.12-8.34-3.8-13.52-11.85-13.52-21.01v-367.24h345c41.35 0 75 33.64 75 75v225h-278.77c-3.62 0-7.11 1.31-9.84 3.68l-93.14 80.99c-4.32 3.76-9.65 5.71-15.08 5.71zm6.84-360.38v322.08l81.69-71.04c8.19-7.12 18.68-11.04 29.53-11.04h248.78v-195c0-24.81-20.19-45-45-45z' />
    <path d='m667.24 659.94c-5.42 0-10.75-1.95-15.08-5.71l-93.14-80.99c-2.73-2.37-6.23-3.68-9.84-3.68h-278.78v-89.65h30v59.65h248.78c10.85 0 21.34 3.92 29.53 11.04l81.69 71.04v-277.08c0-24.81-20.19-45-45-45h-75v-30h75c41.35 0 75 33.64 75 75v292.25c0 9.16-5.18 17.21-13.52 21.01-3.12 1.42-6.4 2.12-9.65 2.12z' />
  </IconBase>
));

Advice.displayName = 'Advice';

export default Advice;
